import { createContext } from "react";

const RefreshContext = createContext({
  triggerRefresh: () => {}
});

export default RefreshContext;
